import { useEffect, useState } from 'react';

export default function useImagePreloader(urls, timeoutMs = 15000) {
  const [progress, setProgress] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let active = true;
    const uniqueUrls = [...new Set(urls)];
    let cachedUrls = null;
    try {
      cachedUrls = JSON.parse(localStorage.getItem('imageUrls') || 'null');
    } catch {
      localStorage.removeItem('imageUrls');
    }

    if (Array.isArray(cachedUrls) && cachedUrls.length === uniqueUrls.length) {
      setProgress(100);
      setIsLoading(false);
      return undefined;
    }

    let completed = 0;
    const recordCompletion = () => {
      completed += 1;
      if (active) setProgress(Math.floor((completed / uniqueUrls.length) * 100));
    };
    const preload = uniqueUrls.map((src) => new Promise((resolve) => {
      const image = new Image();
      image.onload = image.onerror = () => { recordCompletion(); resolve(); };
      image.src = src;
    }));

    Promise.all(preload).then(() => {
      if (!active) return;
      localStorage.setItem('imageUrls', JSON.stringify(uniqueUrls));
      setIsLoading(false);
    });
    const timeout = setTimeout(() => active && setIsLoading(false), timeoutMs);
    return () => { active = false; clearTimeout(timeout); };
  }, [urls, timeoutMs]);

  return { isLoading, progress };
}
